/* unplugin-vue-components disabled */import { render } from "./newsTab.vue?vue&type=template&id=38d1a9af&scoped=true"
import script from "./newsTab.vue?vue&type=script&lang=js"
export * from "./newsTab.vue?vue&type=script&lang=js"

import "./newsTab.vue?vue&type=style&index=0&id=38d1a9af&lang=less&scoped=true"

import exportComponent from "/Users/iwowke/Desktop/work/www/iwowke.com/src/m/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38d1a9af"]])

export default __exports__